import CatalogComponent from '@views/catalog/index';
import CatalogShowComponent from '@views/catalog/show';

export default [
    {
        path: '/catalog',
        component: CatalogComponent,
        name: 'catalog#index',
        meta: {
            header: true,
        },
    },
    {
        path: '/catalog/:catalogPageId',
        component: CatalogShowComponent,
        name: 'catalog#page#show',
    },
];
